import { DOCUMENT } from '@angular/common';
import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Inject, OnInit, Type, ViewChild } from '@angular/core';
import { fadeInOut } from './animations/fade-in-out.animation';
import { InsertionPointDirective } from './directives/insertion-point.directive';
import { DialogToggle } from './model/dialog-toggle';
import { ParentDialogConfiguration } from './model/parent-dialog-configuration';

/** @dynamic */
@Component({
  selector: 'bcd-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  animations: [fadeInOut]
})
export class DialogComponent implements OnInit {

  @ViewChild(InsertionPointDirective, { static: true })
  private insertionPointDirective: InsertionPointDirective;

  public sonComponentType: Type<any>; // Inject from the Service
  public parentComponentRef: ComponentRef<DialogComponent>; // Inject from the Service
  public parentDialogConfiguration: ParentDialogConfiguration; // Inject from the Service

  protected sonComponentRef: ComponentRef<any>;

  constructor(
    private sonComponentFactoryResolver: ComponentFactoryResolver,
    @Inject(DOCUMENT) private document: Document,
    private dialogToggle: DialogToggle<boolean>
  ) { }

  ngOnInit(): void {

    if (this.sonComponentType) {
      const sonComponentFactory = this.sonComponentFactoryResolver.resolveComponentFactory(this.sonComponentType);
      this.sonComponentRef = this.insertionPointDirective.directiveViewContainerRef.createComponent(sonComponentFactory);
    }

    // Delete Scroll
    this.document.body.style.overflow = 'hidden';
  }

  @HostListener('click', ['$event'])
  public onClickOverlay(event: MouseEvent) {
    if (this.parentDialogConfiguration?.operations?.closeWithOverlay) { this.destroyComponentParentAndChild(); }
  }

  public destroyComponentParentAndChild() {
    // IMPORTANTE: EN CONTROL DEBE DE ESTAR DEL LADO DE LA INSTANCIA (PAR ELLO NOTIFICAMOS LA ACCION)
    // this.sonComponentRef.destroy();
    // this.parentComponentRef.destroy();
    this.dialogToggle.notifyClose(false);
    this.document.body.style.overflow = 'initial';
  }

  avoidEvent(event: Event) {
    event.stopPropagation();
  }
}
